import { createSlice } from '@reduxjs/toolkit';
import { catalogListBrand } from './catalogAsyncThunk';

const catalogListBrandSlice = createSlice({
  name: "catalog",
  initialState: {
    payload: [],
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [catalogListBrand.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [catalogListBrand.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = [...action.payload.list];
    },
    [catalogListBrand.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default catalogListBrandSlice.reducer;